import React, { createContext, useContext, useState } from 'react';
import translations from '../Data/translations.json';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('kkb-lang') || 'en');

  const toggleLanguage = () =>
    setLang((prev) => {
      const next = prev === 'en' ? 'ta' : 'en';
      localStorage.setItem('kkb-lang', next);
      return next;
    });

  const setLanguage = (l) => {
    localStorage.setItem('kkb-lang', l);
    setLang(l);
  };

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, t, toggleLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within a LanguageProvider');
  return ctx;
};

export default LanguageContext;